/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { ContentModuleModal, EventField } from '@molecules';
import { NO_MARGIN_BOTTOM } from '@constants';

import Form from '../Form';

import Item from './Item';

const FORM_FIELD = {
  EVENT: {
    label: 'Choose the Event',
    name: 'eventIdWa',
  },
};

const FlashInterviewsModule = ({ visible, onSubmit, hide, onDelete, initialValues, errors }) => {
  const [form] = Form.useForm();

  const handleClose = () => {
    form.resetFields();
    hide();
  };

  const handleSubmit = (values) => {
    onSubmit({ eventIdWa: values.eventIdWa.eventIdWa });
    handleClose();
  };

  return (
    <ContentModuleModal
      okText={onDelete ? 'SAVE CHANGES' : 'ADD STATS'}
      subtitle="Add Flash interviews module"
      title="Flash Interviews"
      onCancel={handleClose}
      onSubmit={form.submit}
      onDelete={onDelete}
      visible={visible}
      errors={errors}
    >
      <Form form={form} layout="vertical" initialValues={initialValues} onFinish={handleSubmit}>
        <EventField
          rules={[{ required: true, message: 'Event is required' }]}
          initialValues={initialValues}
          wrapperCol={{ span: 24 }}
          style={NO_MARGIN_BOTTOM}
          {...FORM_FIELD.EVENT}
          extra={null}
        />
      </Form>
    </ContentModuleModal>
  );
};

FlashInterviewsModule.Item = Item;

export default FlashInterviewsModule;
